<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Exámenes y TPSNS</h4>
    <hr>
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda"
              style="width: 500px; text-transform:uppercase;" required>
          </td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
            </button>
          </td>
          <td class="centro">
            <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros">
              <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
            </button>
          </td>
          <td>
            <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal"
              @click="abrirModalCrear" title="Nuevo registro">
              <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
            </button>
          </td>
        </tr>
      </table>
    </div>

    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Nombre en Formulario</th>
          <th scope="col">Código TPSNS</th>
          <th scope="col">Nombre TPSNS</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="elemexam in datosPaginados" :key="elemexam.idElemExam">
          <td>
            <i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;"
              @click="abrirModalEditar(elemexam.idElemExam)" title="Editar">edit_square</i>
          </td>
          <td>{{ elemexam.examenNombre }}</td>
          <td>{{ elemexam.elementoCodigo }}</td>
          <td>{{ elemexam.elementoNombre }}</td>
          <td>
            <i class="material-icons" style="font-size:16px;color:red; cursor: pointer;"
              @click="deleteElemExam(elemexam.idElemExam)" title="Borrar">delete</i>
          </td>
        </tr>
      </tbody>
    </table>

    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" :key="pagina" @click="getDataPaginaTodos(pagina)" class="page-item" :class="isActive(pagina)">
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>

    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Lista de Valores para Examen -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idExamen" class="form-label">Examen</label>
                  </div>
                  <div class="col-10">
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="searchTextExamen" @input="filterExamens"
                        @focus="showDropdownExamen = true" @blur="hideDropdown('Examen')"
                        placeholder="Buscar examen..." />
                      <ul class="dropdown-menu shadow" :class="{ show: showDropdownExamen }"
                        style="max-height: 250px; overflow-y: auto; width: 100%;">
                        <li v-for="examen in filteredExamens" :key="examen.idExamen">
                          <a class="dropdown-item" href="#" @mousedown.prevent="selectExamen(examen)">
                            {{ examen.nombre }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fin Lista de Valores para Examen -->

              <!-- Lista de Valores para Elemento -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label">Elemento TPSNS</label>
                  </div>
                  <div class="col-10">
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="searchTextElemento" @input="filterElementos"
                        @focus="showDropdownElemento = true" @blur="hideDropdown('Elemento')"
                        placeholder="Buscar elemento..." />
                      <ul class="dropdown-menu shadow" :class="{ show: showDropdownElemento }"
                        style="max-height: 250px; overflow-y: auto; width: 100%;">
                        <li v-for="elemento in filteredElementos" :key="elemento.idElemento">
                          <a class="dropdown-item" href="#" @mousedown.prevent="selectElemento(elemento)">
                            {{ elemento.codigo }} - {{ elemento.nombre }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fin Lista de Valores para Elemento -->
            </div>
          </form>
          <div class="modal-footer">
            <button type="submit" class="btn btn-light" @click.prevent="guardarElemExam" v-if="btnCrear"
              title="Guardar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
            </button>
            <button type="submit" class="btn btn-light" @click.prevent="guardarEditElemExam" v-if="btnEditar"
              title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Layout from '../../components/Layout.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {
  components: {
    Layout, Footer
  },
  data() {
    return {
      elemexams: [],
      datoElemExam: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      elementos: [],
      examens: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      },
      searchTextElemento: '',
      filteredElementos: [],
      showDropdownElemento: false,
      searchTextExamen: '',
      filteredExamens: [],
      showDropdownExamen: false,
    }
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchElementos()
    this.fetchExamens()
  },
  methods: {
    totalPaginas() {
      return Math.ceil(this.elemexams.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != '') {
          api.get('/vwelemexams').then(response => {
//          api.get('/vwelemexams/nombre/' + this.nombreBusqueda).then(response => {
          this.elemexams = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.elemexams.slice(ini, fin);
        });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get('/vwelemexams').then(response => {
        this.elemexams = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
        let fin = (noPagina * this.elementosPorPagina);
        this.datosPaginados = this.elemexams.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm() {
      const requiredFields = [
        'idElemento'
        , 'idExamen'
      ];
      const requiredFieldsText = [
        'idElemento'
        , 'idExamen'
      ];
      return validarForm(this.datoElemExam, requiredFields, requiredFieldsText);
    },
    async guardarElemExam() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/elemexams', this.datoElemExam)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ElemExam creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemExam() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/elemexams', this.datoElemExam)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ElemExam creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true
      this.datoElemExam = {}
      this.titulo = 'Crear '
      this.btnCrear = true
      this.btnEditar = false
      this.searchTextElemento = '';
      this.searchTextExamen = '';
    },
    abrirModalEditar(idElemExam) {
      this.modalWindow = true
      if (idElemExam != null) {
        api.get('/vwelemexams/' + idElemExam).then(resp => {
          this.datoElemExam = resp.data;
          this.searchTextElemento = this.datoElemExam.elementoCodigo + " - " + this.datoElemExam.elementoNombre;
          this.searchTextExamen = this.datoElemExam.examenNombre;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo = 'Editar '
      this.btnCrear = false
      this.btnEditar = true
    },
    async deleteElemExam(idElemExam) {
      try {
        await api.delete('/elemexams/' + idElemExam)
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert('No se pudo eliminar')
      }
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/vwelementos/idclaselem/2')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
    fetchExamens() {
      fetch('http://localhost:8080/api/v1/vwexamens')
        .then(response => response.json())
        .then(data => {
          this.examens = data;
        })
        .catch(error => {
          console.error('Error fetching examens:', error);
        });
    },

    // Ocultar dropdown al perder el foco
    hideDropdown(type) {
      setTimeout(() => {
        if (type === 'Elemento') this.showDropdownElemento = false;
        if (type === 'Examen') this.showDropdownExamen = false;
      }, 200); // Agrega un retraso para permitir el evento click
    },

    // Filtrar elementos
    filterElementos() {
      this.filteredElementos = this.elementos.filter((elemento) =>
        elemento.nombre.toLowerCase().includes(this.searchTextElemento.toLowerCase())
      );
    },

    // Seleccionar un elemento del dropdown
    selectElemento(elemento) {
      this.datoElemExam.idElemento = elemento.idElemento;
      this.searchTextElemento = elemento.nombre;
      this.showDropdownElemento = false; // Ocultar el dropdown
    },

    // Filtrar exámenes
    filterExamens() {
      this.filteredExamens = this.examens.filter((examen) =>
        examen.nombre.toLowerCase().includes(this.searchTextExamen.toLowerCase())
      );
    },

    // Seleccionar un examen del dropdown
    selectExamen(examen) {
      this.datoElemExam.idExamen = examen.idExamen;
      this.searchTextExamen = examen.nombre;
      this.showDropdownExamen = false; // Ocultar el dropdown
    },

  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style>
.dropdown-menu.show {
  display: block;
}
.button:hover {
  border-color: rgb(253, 209, 13);
  box-shadow: 0px 0px 10px 2px rgb(253, 209, 13);
  transform: translateY(-5px);
}
</style>